import { Box, ListItem } from "@mui/material";
import { SmartAutoComplete } from "@nodeon/react-components";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ActionType } from "~/api/GeneratedApi";
import { useActionSearchOptions } from "../hooks/useActionSearchOptions";
import { ActionsTabFormData } from "../tabs/ActionsTab";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type ActionTypesFormTypes = {
  actionType: ActionType | null;
  workCategory: ActionType | null;
  workClasses: ActionType[] | null;
  actions: ActionType[] | null;
};

export const actionTypesDefaultValues = {
  actionType: null,
  workCategory: null,
  workClasses: null,
  actions: null,
};

export const ActionTypesForm = ({ isDisabled }: SharedFormProps) => {
  const { t } = useTranslation("actionSearch");
  const { control, watch } = useFormContext<ActionsTabFormData>();
  const [actions, workCategory, workClasses, actionType] = watch([
    "actions",
    "workCategory",
    "workClasses",
    "actionType",
  ]);

  const filteredActions = React.useMemo(() => {
    const codes: number[] = [];
    actions?.forEach((a) => {
      if (a.actioN_CDE !== undefined) codes.push(a.actioN_CDE);
    });
    return codes;
  }, [actions]);

  const filteredworkClasses = React.useMemo(() => {
    const codes: number[] = [];
    workClasses?.forEach((a) => {
      if (a.actioN_CDE !== undefined) codes.push(a.actioN_CDE);
    });
    return codes;
  }, [workClasses]);

  const { actionDropDown, isLoading } = useActionSearchOptions({
    actions: filteredActions,
    type: actionType?.actioN_CDE,
    workCategory: workCategory?.actioN_CDE,
    workClasses: filteredworkClasses,
  });

  // const resetOptions = React.useCallback(
  //   (resetValues: (keyof ActionTypesFormTypes)[]) => {
  //     resetValues.forEach((o) => resetField(o));
  //   },
  //   [resetField],
  // );

  // React.useEffect(() => {
  //   resetOptions(["action", "workClass"]);
  // }, [resetOptions, workCategory]);

  // React.useEffect(() => {
  //   resetOptions(["action"]);
  // }, [resetOptions, workClass]);

  // React.useEffect(() => {
  //   console.log(`: rr`);
  // }, [actionType]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <SmartAutoComplete<ActionsTabFormData, ActionType, false>
        name="actionType"
        label={t("fairwayReport:type")}
        options={actionDropDown?.types ?? []}
        controllerProps={{ control }}
        disabled={isDisabled || true}
        getOptionLabel={({ codE_NME }) => codE_NME ?? ""}
        isOptionEqualToValue={({ actioN_CDE }, options) =>
          actioN_CDE === options.actioN_CDE
        }
        renderOption={(props, params) => (
          <ListItem {...props} key={`${params.actioN_CDE}-${params.codE_NME}`}>
            {params.codE_NME}
          </ListItem>
        )}
      /> */}
      <SmartAutoComplete<ActionsTabFormData, ActionType, false>
        name="workCategory"
        label={t("workCategory")}
        options={actionDropDown?.workCategory ?? []}
        controllerProps={{ control }}
        disabled={isDisabled}
        loading={isLoading}
        getOptionLabel={({ codE_NME }) => codE_NME ?? ""}
        isOptionEqualToValue={({ actioN_CDE }, options) =>
          actioN_CDE === options.actioN_CDE
        }
        renderOption={(props, params) => (
          <ListItem {...props} key={`${params.actioN_CDE}-${params.codE_NME}`}>
            {params.codE_NME}
          </ListItem>
        )}
      />
      <SmartAutoComplete<ActionsTabFormData, ActionType[], false>
        name="workClasses"
        label={t("workClass")}
        options={(actionDropDown?.workClass as ActionType[][]) ?? []}
        controllerProps={{ control }}
        disabled={isDisabled || !workCategory}
        getOptionLabel={([ac]) => ac.codE_NME ?? ""}
        // eslint-disable-next-line @typescript-eslint/no-shadow
        isOptionEqualToValue={(actions, options) =>
          actions.some((a) =>
            options.some((o) => o.actioN_CDE === a.actioN_CDE),
          )
        }
        loading={isLoading}
        renderOption={(props, params) => (
          <ListItem
            {...props}
            key={`${params[0].actioN_CDE}-${params[0].codE_NME}`}
          >
            {params[0].codE_NME}
          </ListItem>
        )}
      />
      <SmartAutoComplete<ActionsTabFormData, ActionType[], false>
        name="actions"
        label={t("action")}
        options={(actionDropDown?.action as ActionType[][]) ?? []}
        controllerProps={{ control }}
        disabled={isDisabled || !workClasses}
        getOptionLabel={([ac]) => ac.codE_NME ?? ""}
        // eslint-disable-next-line @typescript-eslint/no-shadow
        isOptionEqualToValue={(actions, options) =>
          actions.some((a) =>
            options.some((o) => o.actioN_CDE === a.actioN_CDE),
          )
        }
        loading={isLoading}
        renderOption={(props, params) => (
          <ListItem
            {...props}
            key={`${params[0].actioN_CDE}-${params[0].codE_NME}`}
          >
            {params[0].codE_NME}
          </ListItem>
        )}
      />
    </Box>
  );
};
